// ops — админский домашний виджет iPhone (Scriptable).
// GET /api/ops/widget у weern-ops, Bearer OPS_WIDGET_TOKEN в заголовке.
import { z } from 'zod';

const stamp = z.string().nullable(); // ISO или null, если событий не было

export const OpsWidgetResSchema = z.object({
  generated_at: z.string(),
  // work: снято фотографами сегодня (киевский день)
  photo: z.object({ today: z.number(), last_at: stamp }),
  // work: принято от dev-отдела сегодня
  dev: z.object({ today: z.number(), last_at: stamp }),
  // internal (pothos_assets): очередь проверки
  qa: z.object({ queue: z.number(), last_at: stamp }),
  // internal (pothos_assets): реально отгрузится сейчас — финализированные
  // accepted (participant_id заполнен, pack_hold пуст)
  ready: z.object({ count: z.number() }),
});
export type OpsWidgetRes = z.infer<typeof OpsWidgetResSchema>;
